import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CheckoutService } from '../checkout.service';
import { SharedService } from '../../shared.service';
import { CartService } from '../../cart/cart.service';
import { CouponFieldData } from 'app/interfaces/CouponFieldData';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit {
  @Input()
  hideCouponForm;

  @Input()
  couponConfirmation;

  @ViewChild('couponInput')
  couponInput: ElementRef;

  public couponForm: FormGroup;
  public couponFieldIsfilled: Boolean = false;
  public errorMessage: string[] = [];
  public env: string;

  constructor(
    private checkoutService: CheckoutService,
    private cartService: CartService,
    private sharedService: SharedService
  ) {
    this.env = this.sharedService.getEnvironment();
  }

  ngOnInit() {
    // Get coupon data from session storage
    const storedCouponData: CouponFieldData =
      this.sharedService.getSessionStorage('couponData');

    // Get site config
    const siteConfig = this.sharedService.getSiteConfig();

    // Create coupon form
    this.couponForm = new FormGroup({
      // Prefill input field with coupon from storage
      couponCode: new FormControl(storedCouponData.code || '', [
        Validators.required,
        Validators.minLength(4)
      ])
    });

    // Mark coupon field as filled to enable button and show X (close) icon
    if (storedCouponData && storedCouponData.code) {
      this.couponFieldIsfilled = true;
    }

    // Submit coupon form and hide it if successfully when
    // a coupon code is set via config or via coupon-set
    if (
      storedCouponData &&
      storedCouponData.code &&
      (this.sharedService.getCookie('coupon-set') || siteConfig.coupon)
    ) {
      this.submitCoupon(true);
    } else if (
      storedCouponData &&
      storedCouponData.code &&
      storedCouponData.submitted
    ) {
      this.submitCoupon(false);
    }

    /*
     * Write to localStorage on form changes
     */
    this.couponForm.valueChanges.subscribe((data) => {
      if (data.couponCode.length === 0) {
        this.checkoutService.setConfirmValidation(true);
        this.couponFieldIsfilled = false;
      } else {
        this.couponFieldIsfilled = true;
      }
    });
  }

  emptyCouponField() {
    this.couponForm.controls.couponCode.setValue('');
    this.cartService.setDiscount(0, '');
    this.couponConfirmation = null;
    this.sharedService.removeFromSessionStorage('couponData');
    this.couponInput.nativeElement.focus();
  }

  submitCoupon(hideAfterSubmit = false) {
    const couponData = {
      code: this.couponForm.value.couponCode,
      products: this.cartService.getProductsForOrder()
    };
    const submitId = this.sharedService.generateRandomHash();

    this.checkoutService.validateCoupon(couponData).subscribe(
      (response) => {
        // Set coupon in sessionStorage if coupon is correct
        this.sharedService.setSessionStorage('couponData', {
          code: couponData.code,
          submitted: true
        });

        // Set discount via cartService
        this.cartService.setDiscount(response.discount, response.code);
        this.checkoutService.setConfirmValidation(true);
        this.errorMessage = [];
        this.couponConfirmation = response;
        this.sharedService.pushCustomToDataLayer(
          {
            event: 'coupon success',
            category: submitId
          },
          false
        );

        if (hideAfterSubmit) {
          this.hideCouponForm = true;
        }
      },
      (errorResponse) => {
        this.cartService.setDiscount(0, '');
        this.couponConfirmation = null;
        this.couponForm.controls.couponCode.setErrors({
          notReal: true
        });
        this.errorMessage =
          errorResponse && errorResponse.error ? errorResponse.error.msgs : [];
        this.sharedService.removeFromSessionStorage('couponData');
        this.sharedService.pushErrorToDataLayer(this.errorMessage, submitId);
      }
    );
  }
}
